import 'highlight.js/styles/github-dark.css'

import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { common, createLowlight } from 'lowlight'

import { CodeBlockSelector } from './CodeBlockSelector'

const lowlight = createLowlight(common)

export const CustomizeCodeBlock = CodeBlockLowlight.extend({
    addNodeView() {
        return ReactNodeViewRenderer(CodeBlockSelector)
    }
}).configure({
    lowlight,
    defaultLanguage: 'sql'
})
